// Vibrant avatar colors echoing the SE branding palette (green, sky blue, purple, amber, coral).
// Plain hex values so an avatar's color is stable regardless of color mode.
export const AVATAR_PALETTE = ['#3DCD58', '#42B4E6', '#9B51E0', '#E2A33F', '#DB5E52'] as const;

/** First letter of the email, uppercased. Falls back to "?" when there is nothing to show. */
export function getAvatarInitial(email: string): string {
  return email.trim()[0]?.toUpperCase() ?? '?';
}

/**
 * Deterministically maps an email to a palette color by summing its char codes.
 * The same email always yields the same color; comparison is case-insensitive.
 */
export function getAvatarColor(email: string): string {
  const normalized = email.trim().toLowerCase();
  if (!normalized) return AVATAR_PALETTE[0];
  const sum = [...normalized].reduce((total, char) => total + char.charCodeAt(0), 0);
  return AVATAR_PALETTE[sum % AVATAR_PALETTE.length];
}
